module.exports = __webpack_public_path__ + "img/info.1c91eacc.svg";